import { Star } from '@phosphor-icons/react';

export type MapPlace = {
  id: string;
  name: string;
  address: string;
  image?: string;
  rating?: number | string;
  type: string;
};

type PlaceMarkerProps = {
  place: MapPlace;
  onClick: () => void;
};

export default function PlaceMarker({ place, onClick }: PlaceMarkerProps) {
  const rating = Number(place.rating) || 0;
  const label = rating
    ? `${place.name} · ${rating.toFixed(1)} / 5`
    : place.name;

  return (
    <button className="place-marker" onClick={onClick} title={label} aria-label={label}>
      <img src={place.image || '/place-placeholder.svg'} alt="" />
      {rating > 0 && (
        <span className="marker-rating">
          <Star weight="fill" />
          <b>{rating.toFixed(1)}</b>
        </span>
      )}
    </button>
  );
}
